//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Form from 'vform'
import { mapGetters } from 'vuex'
import veeValidate from '~/mixins/veeValidate'
import { Breadcrumbs } from '~/plugins/breadcrumbs'
import { asyncDataCatch, asyncDataStart } from '~/utils/asyncData'
import translateGraphQL from '~/filters/translateGraphQL'
import SubmitCodeModal from '~/components/modal/submit-code-modal'
import VueToastMixin from '~/mixins/plugins/vue-toastification'
import CandidatesPortalModal from '~/components/modal/login-candidate-portal-modal'
import RestoreCodeModal from '~/components/modal/restore-code-modal'

export default {
  name: 'WorkWithTubberJobApply',
  components: {
    RestoreCodeModal,
    CandidatesPortalModal,
    SubmitCodeModal
  },
  mixins: [veeValidate, VueToastMixin],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      let page = null
      const lang = ctx.store.getters['lang/locale']
      const { data } = await ctx.$axios.get('/api/content-page?link=careers&lang=' + lang + '&job=' + ctx.route.params.jobId)
      page = data

      await ctx.store.dispatch('data/getCrewListCountries')

      const crubms = Breadcrumbs.get(ctx.app.i18n, 'page', ctx.route, [{
        title: ctx.app.i18n.t('careers-new'),
        url: ctx.app.router.resolve({ name: 'work-with-tubber' }).href
      }, {
        title: page.job.Posting_Title,
        url: ctx.app.router.resolve({ name: 'work-with-tubber-job', params: { jobId: page.job.id } }).href
      }, {
        title: ctx.app.i18n.t('submit-your-cv'),
        url: ctx.route.fullPath
      }])

      await ctx.store.dispatch('setBreadcrumbs', crubms)

      if (Object.keys(page).length === 0) {
        ctx.redirect(301, ctx.app.router.resolve({ name: 'work-with-tubber' }).href)
        return
      }

      return {
        lang,
        page
      }
    } catch (e) {
      return asyncDataCatch(ctx, e)
    }
  },
  data () {
    return {
      form: new Form({
        salutation: '-',
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        street: '',
        postalCode: '',
        city: '',
        country: '',
        skills: '',
        experience: '',
        linkedin: '',
        facebook: '',
        salaryExpected: '',
        salaryCurrent: '',
        comment: '',
        cvFile: '',
        langEN: '-',
        langNL: '-',
        langDE: '-',
        photo: '',
        photoLink: '',
        cvFileLink: ''
      }),
      formRules: {
        salutation: '',
        first_name: 'required',
        last_name: 'required',
        email: 'required|email',
        phone_number: 'required|phone'
      },
      busy: {
        form: false
      },
      filled: false,
      email: ''
    }
  },
  head () {
    return {
      title: this.page.job.Posting_Title + ' - ' + this.page.data.meta_title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.page.data.meta_descrtiption
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.page.data.meta_keywords
        }
      ]
    }
  },
  created () {
    if (this.user) {
      this.form.first_name = this.user.first_name
      this.form.last_name = this.user.last_name
      this.form.email = this.user.email
      this.form.phone_number = this.user.phone
    }
    if (process.client) {
      const candidate = window.localStorage.getItem('applicantData')
      if (candidate) {
        const data = JSON.parse(candidate)
        if (data && data.first_name) {
          this.fillCandidate(data)
          this.filled = true
        }
      }
    }
  },
  mounted () {
    this.$nuxt.$on('successJobPost', (ev) => {
      this.$toast.success(this.$t('job-submitted'))
      this.$refs.formObs.reset()
      this.form.reset()
    })
    this.$nuxt.$on('successLogin', (ev) => {
      if (ev && ev.candidate) {
        window.localStorage.setItem('applicantData', JSON.stringify(ev.candidate))
        this.fillCandidate(ev.candidate)
        this.filled = true
      }
    })
  },
  computed: {
    ...mapGetters({
      locale: 'lang/locale',
      user: 'auth/user',
      ipInfo: 'ip'
    }),
    getFormEmail () {
      return this.form.email
    },
    listCountries () {
      return this.$store.getters['data/crewListCountries'].map((c) => {
        return {
          ...c,
          id: c.short_code3,
          name: translateGraphQL(c, this.locale, 'name')
        }
      })
    },
    salut () {
      return [
        { id: '-', name: this.$t('none') },
        { id: 'Mr.', name: this.$t('mr') },
        { id: 'Mrs.', name: this.$t('mrs') },
        { id: 'Ms.', name: this.$t('ms') }
      ]
    },
    langSkill () {
      return [
        { id: '-', name: '-' },
        { id: 'basic', name: this.$t('basic') },
        { id: 'elementary', name: this.$t('elementary') },
        { id: 'intermediate', name: this.$t('intermediate') },
        { id: 'advanced', name: this.$t('advanced') },
        { id: 'fluent', name: this.$t('fluent') }
      ]
    }
  },
  methods: {
    fillCandidate (ev) {
      this.form.salutation = ev.salutation
      this.form.first_name = ev.first_name
      this.form.last_name = ev.last_name
      this.form.email = ev.email
      this.form.phone_number = ev.phone_number
      this.form.street = ev.street
      this.form.postalCode = ev.postal_code || ev.postalCode
      this.form.city = ev.city
      this.form.country = ev.country
      this.form.skills = ev.skills
      this.form.experience = ev.experience
      this.form.salaryExpected = ev.salaryExpected
      this.form.salaryCurrent = ev.salaryCurrent

      this.form.cvFile = ev.cv_file || ev.cvFile
      this.form.photo = ev.photo

      const commentParts = ev.comment.split('|')
      this.form.comment = commentParts[0]
      if (commentParts[1]) {
        const additionalData = commentParts[1].split(',')
        additionalData.forEach((dt) => {
          if (dt) {
            const values = dt.split(':')
            this.form[values[0]] = values[1].trim()
          }
        })
      }
    },
    findCountryInList (ctx, list, value) {
      return list.filter((v) => {
        return v?.name?.toLowerCase()?.includes(value.toLowerCase()) || v.id.toLowerCase()?.includes(value.toLowerCase())
      })
    },
    loginPortal () {
      this.$modal.show('candidates-portal-modal')
    },
    deleteFile (type) {
      if (!type) {
        return
      }
      let path
      switch (type) {
        case 'cvFile':
          path = this.form.cvFile
          this.form.cvFileLink = ''
          this.form.cvFile = ''
          break
        case 'photo':
          path = this.form.photo
          this.form.photoLink = ''
          this.form.photo = ''
          break
        default:
          break
      }
      if (path) {
        this.$axios.post('/api/jobs/documents/delete', { path })
      }
    },
    async uploadFunc (files, e) {
      const name = e?.target?.attributes?.name?.value
      this.form.errors.clear(name)
      const formData = new FormData()
      formData.append('files[]', files[0])

      const response = await this.$axios.post('/api/jobs/upload', formData).catch((resp) => {
        this.form.errors.set(name, resp.response.data.message || this.$t('data-not-updated-please-try-again'))
      })
      switch (name) {
        case 'cvFile':
          this.form.cvFileLink = response.data.uploaded_file_url
          this.form.cvFile = response.data.path
          break
        case 'photo':
          this.form.photoLink = response.data.uploaded_file_url
          this.form.photo = response.data.path
          break
        default:
          break
      }
      return response
    },
    setPhoneActiveCountry (obj = null) {
      const dialCode = obj?.dialCode
      if (dialCode) {
        this.formRules.phone_number = `required|phone:${dialCode}`
      } else {
        this.formRules.phone_number = 'required|phone'
      }
    },
    async save () {
      this.busy.form = true
      const code = window.localStorage.getItem('jobsCode')
      const form = this.form.data()
      if (form.email != '') {
        this.email = form.email
      }
      const isValid = await this.$refs?.formObs?.validate()
      const token = ''// await this.$recaptcha.getResponse()
      form.comment += '|Info:,'
      form.comment += `linkedin: ${form.linkedin},`
      form.comment += `facebook: ${form.facebook},`
      form.comment += `langEN: ${form.langEN},`
      form.comment += `langNL: ${form.langNL},`
      form.comment += `langDE: ${form.langDE}`
      const request = {
        ...form,
        jobId: this.page.job.id,
        verification_code: code,
        gRecaptchaResponse: token
      }
      window.localStorage.setItem('applicantData', JSON.stringify(request))
      if (isValid) {
        this.$axios.post('/api/jobs/save-candidate', request)
          .then((data) => {
            this.busy.form = false
            if (data.data.message === 'verification_requested') {
              this.$modal.show('submit-code-modal', { email: this.email })
              return
            } else {
              this.$toast.success(this.$t('job-submitted'))
            }
            this.$refs.formObs.reset()
            this.form.reset()
          })
          .catch((error) => {
            const msg = error.response?.data?.message
            this.busy.form = false
            this.$toast.error(this.$t('error') + (msg ? ' ' + this.$t(msg) : ''))
          })
      } else {
        this.busy.form = false
      }
    }
  }
}
